import React, { useEffect } from "react"
import { Modal, Toast } from "antd-mobile"
import { useHistory } from "react-router-dom"

import modStyl from './index.module.scss'

import UserInfo from "../components/user-info"
import WithDockLayout from "../components/with-dock-layout"
import Cell from "./components/cell"
import LazyIcon from "../components/lazy-icon"

const JunProfile = ()=> {
  const his = useHistory()

  const exitConfirm = ()=> {
    Modal.alert('', '是否退出登录？', [
      {
        text: '取消',
        onPress: ()=> {},
      },
      {
        text: '确定',
        onPress: ()=> {
          his.replace('/login')
        }
      }
    ])
  }

  useEffect(()=> {
    window.document.title = '我的'
  }, [])

  const upcoming = ()=> {
    Toast.show('敬请期待')
  }

  const items = [
    {key: 1, label: '邀请患者二维码', onClick: upcoming, icon: <LazyIcon name="qr" />},
    {key: 2, label: '我参与的项目', onClick: upcoming, icon: <LazyIcon name="card-list" />},
    {key: 3, label: '医生主页', onClick: upcoming, icon: <LazyIcon name="card" />},
    {key: 4, label: '用户协议', href: '/v2/terms-of-service', icon: <LazyIcon name="file" />},
  ]

  return (
    <WithDockLayout>
      <div className={modStyl.body}>
        <UserInfo mode={1} />
        <div className={modStyl.body}>
          <Cell items={items}/>
        </div>
        <div className={modStyl.footer}>
          <button onClick={exitConfirm} type="button">
            退出
          </button>
        </div>
      </div>
    </WithDockLayout>
  );
}

export default JunProfile